import styles from './HelpDialogs.module.scss'

const { close, confirm, dialog, header, holder, mainTitle, overlay } = styles

const HelpDialog = ({ handleHideDialog, title, children, noPadding, className }) => (
  <div className={holder}>
    <div className={overlay} onClick={handleHideDialog}></div>
    <div className={[dialog, className].join(' ')}>
      <div className={header}>
        <h1 className={mainTitle}>{title}</h1>
        <button className={close} onClick={handleHideDialog}></button>
      </div>
      <div className={noPadding ? '' : confirm}>{children}</div>
    </div>
  </div>
)

export default HelpDialog
